import { c as _c } from "react/compiler-runtime";
import { tv } from 'tailwind-variants';
import { Body } from '../typography/Body';
import { FlexContainer } from './FlexContainer';
import type { VariantProps } from 'tailwind-variants';
const code = tv({
  base: 'bg-background-secondary border border-border-secondary rounded p-3 gap-2 font-mono',
  variants: {
    variant: {
      block: 'w-full',
      inline: 'inline-flex w-fit px-1 py-0.5 text-sm items-center'
    }
  },
  defaultVariants: {
    variant: 'block'
  }
});
export interface CodeProps extends VariantProps<typeof code> {
  children: React.ReactNode;
  className?: string;
  /** Content to display before the main code content */
  prefix?: React.ReactNode;
  /** Content to display after the main code content */
  postfix?: React.ReactNode;
}

/**
 * Code component for displaying code snippets, IDs, or technical content.
 * Renders content in a styled container with monospace font.
 */
export function Code(t0) {
  const $ = _c(26);
  const {
    children,
    className,
    variant: t1,
    prefix,
    postfix
  } = t0;
  const variant = t1 === undefined ? "block" : t1;
  if (variant === "inline") {
    let t2;
    if ($[0] !== className || $[1] !== variant) {
      t2 = code({
        variant,
        className
      });
      $[0] = className;
      $[1] = variant;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    let t3;
    if ($[3] !== prefix) {
      t3 = prefix && <span className="shrink-0">{prefix}</span>;
      $[3] = prefix;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    let t4;
    if ($[5] !== postfix) {
      t4 = postfix && <span className="shrink-0">{postfix}</span>;
      $[5] = postfix;
      $[6] = t4;
    } else {
      t4 = $[6];
    }
    let t5;
    if ($[7] !== children || $[8] !== t2 || $[9] !== t3 || $[10] !== t4) {
      t5 = <code className={t2}>{t3}{children}{t4}</code>;
      $[7] = children;
      $[8] = t2;
      $[9] = t3;
      $[10] = t4;
      $[11] = t5;
    } else {
      t5 = $[11];
    }
    return t5;
  }
  let t2;
  if ($[12] !== className || $[13] !== variant) {
    t2 = code({
      variant,
      className
    });
    $[12] = className;
    $[13] = variant;
    $[14] = t2;
  } else {
    t2 = $[14];
  }
  let t3;
  if ($[15] !== prefix) {
    t3 = prefix && <span className="shrink-0">{prefix}</span>;
    $[15] = prefix;
    $[16] = t3;
  } else {
    t3 = $[16];
  }
  let t4;
  if ($[17] !== children) {
    t4 = <Body className="text-content-primary font-mono break-all" size="sm">{children}</Body>;
    $[17] = children;
    $[18] = t4;
  } else {
    t4 = $[18];
  }
  let t5;
  if ($[19] !== postfix) {
    t5 = postfix && <span className="shrink-0">{postfix}</span>;
    $[19] = postfix;
    $[20] = t5;
  } else {
    t5 = $[20];
  }
  let t6;
  if ($[21] !== t2 || $[22] !== t3 || $[23] !== t4 || $[24] !== t5) {
    t6 = <FlexContainer className={t2} direction="row" items="center">{t3}{t4}{t5}</FlexContainer>;
    $[21] = t2;
    $[22] = t3;
    $[23] = t4;
    $[24] = t5;
    $[25] = t6;
  } else {
    t6 = $[25];
  }
  return t6;
}
export { code };